import get from 'lodash/get';
import assign from 'lodash/assign';
import striptags from 'striptags';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData[site] || {};
  const siteHumanReadable = get(siteConf, '[og:site_name]');
  const wpPage = get(state, 'customPage.data.page[0]');
  const slug = get(wpPage, 'slug');
  const pageTitle = get(wpPage, 'title.rendered');
  const wpExcerpt = get(wpPage, 'excerpt.rendered');
  const description = wpExcerpt ? striptags(wpExcerpt).trim() : '';

  const slugLookup = {
    'world-changing-ideas': {
      title: 'World Changing Ideas | Fast Company',
      description:
        'Rewarding ideas, projects, and products from the last year that have the potential to alter the lives of people and the direction of the planet for the better.',
      articleSection: 'World Changing Ideas'
    },
    'most-innovative-companies': {
      title: 'Most Innovative Companies | Fast Company',
      description:
        "Designating the world's most innovative companies to reflect today’s expanding innovation efforts across the business landscape.",
      articleSection: 'Most Innovative Companies'
    },
    about: {
      title: 'Innovation By Design Awards | Co.Design ',
      description:
        'We honor the designers and businesses solving the problems of today and tomorrow. We have featured a cross-section of blue-chip companies, scruffy startups, and hungry young talents.',
      articleSection: 'Innovation By Design Award About'
    }
  };

  const foundStaticConfig = slugLookup[slug] || {};

  const base = {
    site,
    siteConf,
    url: `https://www.${site}.com/${slug}`,
    title: siteHumanReadable || '',
    articleSection: pageTitle,
    description
  };

  const union = assign({}, base, foundStaticConfig);

  const data = baseSeoUtil(union);
  return data;
}



// WEBPACK FOOTER //
// ./src/utils/seo_utils/wp_page_seo_util.js